import { combineReducers } from 'redux';
import { loadingBarReducer } from 'react-redux-loading-bar';
import infoBoxReducer from '../components/InfoBox/infoBoxReducer.js';
import editPortletDataReducer from './EditPortletDataReducer.js';

const RootReducer = combineReducers({
  loadingBar: loadingBarReducer,
  infoBox: infoBoxReducer,
  editPortletData: editPortletDataReducer
});

export default RootReducer;


// WEBPACK FOOTER //
// ./src/reducers/RootReducer.js